import ContentsTypes from "@shared/enums/contentsTypes";
import { createColorImageBlock } from "@project/templates/colorImageBlock";
export const createStepsItem = (steps, lastStepBackgroundColor = "") => ({
    key: "dynamicElements",
    type: "ROW",
    value: "",
    children: [
        {
            key: "items",
            type: "STEPS",
            value: "",
            children: [
                {
                    key: "dynamicList",
                    type: ContentsTypes.DYNAMIC_LIST,
                    value: "",
                    children: [
                        {
                            key: "contentType",
                            value: "STEP",
                            children: steps.map((step, index) => ({
                                key: "items",
                                type: "STEP",
                                value: "",
                                children: [
                                    {
                                        key: "title",
                                        type: ContentsTypes.INPUT,
                                        value: step.title,
                                    },
                                    {
                                        key: "description",
                                        type: ContentsTypes.INPUT,
                                        value: step.description,
                                    },
                                    {
                                        key: "borderColor",
                                        type: ContentsTypes.COLOR,
                                        value: step.borderColor,
                                    },
                                    {
                                        key: "backgroundColor",
                                        type: ContentsTypes.COLOR,
                                        value: step.backgroundColor ||
                                            (index === steps.length - 1
                                                ? lastStepBackgroundColor
                                                : ""),
                                    },
                                ],
                            })),
                        },
                    ],
                },
            ],
        },
        createColorImageBlock("130", "316", "593", "", "#fff", "back_office", "#1C1C1E"),
        { key: "justifyContent", type: ContentsTypes.SELECT, value: "flex-start" },
        { key: "spacing", type: "SLIDER", value: "50" },
        { key: "columnOnMobile", type: "CHECKBOX", value: "false" },
        { key: "useFlexWrap", type: "CHECKBOX", value: "false" },
    ],
});
